/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetGipMetadataVersionsQueryResponse, AuditReportsGetGipMetadataVersionsQueryParams, AuditReportsGetGipMetadataVersions401, AuditReportsGetGipMetadataVersions403 } from "../models/AuditReportsGetGipMetadataVersions";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { auditReportsGetGipMetadataVersions } from "../axios/auditReportsGetGipMetadataVersions";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const auditReportsGetGipMetadataVersionsQueryKey = (params: AuditReportsGetGipMetadataVersionsQueryParams) => ["api-v2", { url: '/audit-reports/v1/reports/gip/metadata/versions' }, ...(params ? [params] : [])] as const

export type AuditReportsGetGipMetadataVersionsQueryKey = ReturnType<typeof auditReportsGetGipMetadataVersionsQueryKey>

export function auditReportsGetGipMetadataVersionsQueryOptions(params: AuditReportsGetGipMetadataVersionsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = auditReportsGetGipMetadataVersionsQueryKey(params)
        return queryOptions<AuditReportsGetGipMetadataVersionsQueryResponse, ResponseErrorConfig<AuditReportsGetGipMetadataVersions401 | AuditReportsGetGipMetadataVersions403>, AuditReportsGetGipMetadataVersionsQueryResponse, typeof queryKey>({
         enabled: !!(params),
         queryKey,
         queryFn: async ({ signal }) => {
            return auditReportsGetGipMetadataVersions(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Return GIP versions for stations in a range
 * {@link /audit-reports/v1/reports/gip/metadata/versions}
 */
export function useAuditReportsGetGipMetadataVersions<TData = AuditReportsGetGipMetadataVersionsQueryResponse, TQueryData = AuditReportsGetGipMetadataVersionsQueryResponse, TQueryKey extends QueryKey = AuditReportsGetGipMetadataVersionsQueryKey>(params: AuditReportsGetGipMetadataVersionsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<AuditReportsGetGipMetadataVersionsQueryResponse, ResponseErrorConfig<AuditReportsGetGipMetadataVersions401 | AuditReportsGetGipMetadataVersions403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? auditReportsGetGipMetadataVersionsQueryKey(params)
         

         const query = useQuery({
          ...auditReportsGetGipMetadataVersionsQueryOptions(params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AuditReportsGetGipMetadataVersions401 | AuditReportsGetGipMetadataVersions403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}